import { Phone, Mail } from "lucide-react";
import { CONTACT } from "../../data/site";

export const MobileContactBar = () => (
  <div className="fixed inset-x-3 bottom-3 z-40 grid grid-cols-2 gap-2 rounded-full border border-ink/10 bg-canvas/90 p-1.5 shadow-[0_12px_40px_-12px_rgba(17,24,39,0.45)] backdrop-blur-xl md:hidden" data-testid="mobile-contact-bar">
    <a href={CONTACT.phoneHref} className="flex items-center justify-center gap-2 rounded-full bg-ink py-3 text-sm font-semibold text-canvas" data-testid="mobile-call-button">
      <Phone className="h-4 w-4" /> Call us
    </a>
    <a href={`mailto:${CONTACT.email}`} className="flex items-center justify-center gap-2 rounded-full bg-flame py-3 text-sm font-semibold text-white" data-testid="mobile-email-button">
      <Mail className="h-4 w-4" /> Email us
    </a>
  </div>
);
